import React, { useMemo, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Divider,
  Typography,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import "./index.css";
import Image from "next/image";
import { AddToCartService } from "../../../services/cart";
import ShareIcon from "@mui/icons-material/Share";
import Coin from "../../../assets/stcoin.png";
import WatchLaterIcon from "@mui/icons-material/WatchLater";

import { useRouter } from "next/navigation";
import { Guide } from "./Guide";
import { useCurrencyCode } from "../helper-functions/CurrencySymbol";
import MaxServiceAlert from "./MaxServiceAlert";
import ShareService from "../share/ShareService";
import BestPairedDesktop from "./BestPairedDesktop";

interface MobileCardProps {
  id: any;
  cid: any;
  url: any;
  bannerUrl: any;
  heading: any;
  subHeading: any;
  finalPrice: any;
  discount: any;
  price: any;
  addOn: any;
  serviceDetails: any;
  handleViewDetails: any;
  min: any;
  coin: any;
  handleOpenViewDetailsRsOne: any;
  updateCard: any;
  setUpdateCard: any;
  productDetailsAvailable: any;
  reloadViewDetailsItem: any;
  makeYourOwnPackage: boolean;
  handleEditPackage: any;
  recommendedServices: any;
  handleViewDetailsBestPaired: any;
  aboutList: any;
  serviceCharge: any;
  productCost: any;
  specialPrice: any;
  specialMessage: any;
}

export const MobileCard: React.FC<MobileCardProps> = ({
  id,
  cid,
  url,
  bannerUrl,
  heading,
  subHeading,
  finalPrice,
  discount,
  price,
  addOn,
  serviceDetails,
  handleViewDetails,
  min,
  coin,
  handleOpenViewDetailsRsOne,
  updateCard,
  setUpdateCard,
  productDetailsAvailable,
  reloadViewDetailsItem,
  makeYourOwnPackage,
  handleEditPackage,
  recommendedServices,
  handleViewDetailsBestPaired,
  aboutList,
  serviceCharge,
  productCost,
  specialPrice,
  specialMessage,
}) => {
  const [isClicked, setIsClicked] = useState(false);
  const [value, setVaue] = useState(1);
  const [openMaxService, setOpenMaxService] = useState(false);
  const [openShareDrawer, setOpenShareDrawer] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const router = useRouter();
  const addToCartService = useMemo(() => new AddToCartService(), []);
  const currencyCode = useCurrencyCode();

  const hours = Math.floor(min / 60);
  const minutes = min % 60;
  const formattedHours = hours < 10 ? `0${hours}` : hours;

  React.useEffect(() => {
    var jsonCount = addToCartService.checkIfAvailable(id, cid);
    if (jsonCount.count > 0) {
      setIsClicked(true);
      setVaue(jsonCount.count);
    } else {
      setIsClicked(false);
    }
    setUpdateCard(false);
  }, [updateCard, addToCartService, cid, id, setUpdateCard]);

  const handleClickButton = async () => {
    setIsLoading(true);
    // console.log(id);
    if (addOn == true) {
      handleOpenViewDetailsRsOne();
      setIsLoading(false);
    } else {
      var countJson = await addToCartService.addToCart(
        id,
        true,
        cid,
        url,
        aboutList,
        subHeading,
        serviceCharge,
        productCost,
        min,
        specialPrice,
        specialMessage
      );
      if (countJson?.count && countJson?.count > 0) {
        setVaue(countJson.count);
        setIsClicked(true);
        reloadViewDetailsItem();
        setIsLoading(false);
      } else {
        setIsClicked(false);
        reloadViewDetailsItem();
        setIsLoading(false);
      }
    }
  };

  const handleValueDecrease = async () => {
    setIsLoading(true);
    var countJson = await addToCartService.addToCart(
      id,
      false,
      cid,
      url,
      aboutList,
      subHeading,
      serviceCharge,
      productCost,
      min,
      specialPrice,
      specialMessage
    );
    if (countJson?.count && countJson?.count > 0) {
      setVaue(countJson.count);
      setIsClicked(true);
      reloadViewDetailsItem();
      setIsLoading(false);
    } else {
      setIsClicked(false);
      reloadViewDetailsItem();
      setIsLoading(false);
    }
  };

  const handleValueIncrease = async () => {
    setIsLoading(true);
    var countJson = await addToCartService.addToCart(
      id,
      true,
      cid,
      url,
      aboutList,
      subHeading,
      serviceCharge,
      productCost,
      min,
      specialPrice,
      specialMessage
    );
    if (countJson?.count && countJson?.count > 0) {
      setVaue(countJson.count);
      setIsClicked(true);
      reloadViewDetailsItem();
      if (countJson?.count === 5) {
        setOpenMaxService(true);
      }
      setIsLoading(false);
    } else {
      setIsClicked(false);
      reloadViewDetailsItem();
      setIsLoading(false);
    }
  };

  const handleReferEarnNavigate = (e: any) => {
    e.preventDefault();
    setOpenShareDrawer(true);
    // router.push("/refer&earn");
  };

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        boxSizing: "border-box",
        overflowX: "hidden",
      }}
    >
      <Box
        sx={{
          m: { xs: "0.5rem auto", sm: 0 },
          width: { xs: "calc(100% - 16px)", sm: "100%" },
          maxWidth: "100%",
          minWidth: 0,
          boxSizing: "border-box",
          boxShadow: bannerUrl ? "rgba(0, 0, 0, 0.1) 0px 1px 4px 2px" : "none",
          borderRadius: bannerUrl ? "1rem" : "none",
          overflow: "hidden",
        }}
      >
        {bannerUrl && (
          <Image
            src={bannerUrl}
            alt="icon"
            style={{
              objectFit: "cover",
              width: "100%",
              height: "auto",
              minHeight: "4rem",
              maxHeight: "8rem",
              borderRadius: "1rem 1rem 0px 0px",
            }}
            loading="lazy"
            width={500}
            height={500}
          />
        )}
        <Box
          sx={{
            p: { xs: "0.5rem", sm: 2 },
            width: "100%",
            boxSizing: "border-box",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              maxWidth: "100%",
              minWidth: 0,
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                minWidth: 0,
                flex: 1,
                pr: 0.5,
              }}
            >
              {!bannerUrl && (
                <Box>
                  <Image
                    src={url}
                    alt="icon"
                    style={{
                      objectFit: "cover",
                      width: "4rem",
                      height: "4rem",
                      minHeight: "4rem",
                      maxWidth: "4rem",
                      borderRadius: "100%",
                      marginRight: "8px",
                    }}
                    loading="lazy"
                    width={500}
                    height={500}
                  />
                </Box>
              )}
              <Box sx={{ minWidth: 0 }}>
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: "bold",
                    fontSize: "12px",
                    marginBottom: "5px",
                    textTransform: "capitalize",
                  }}
                >
                  {heading}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ fontSize: "12px", textTransform: "capitalize" }}
                >
                  {subHeading}
                </Typography>
              </Box>
            </Box>
            <Box sx={{ flexShrink: 0, pl: "0.5rem" }}>
              {isLoading ? (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "115px",
                    background: "none",
                    borderRadius: "10rem",
                    border: "1px solid #15741a",
                    height: "32px",
                  }}
                >
                  <CircularProgress size="25px" color="success" />
                </Box>
              ) : isClicked ? (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-evenly",
                    width: "115px",
                    height: "32px",
                    background: "#15741a",
                    borderRadius: "10rem",
                    color: "white",
                  }}
                >
                  <RemoveIcon
                    onClick={handleValueDecrease}
                    sx={{ cursor: "pointer" }}
                  />
                  <Typography
                    sx={{
                      fontSize: "14px",
                    }}
                  >
                    {value}
                  </Typography>
                  <AddIcon
                    onClick={handleValueIncrease}
                    sx={{ cursor: "pointer" }}
                  />
                </Box>
              ) : (
                <Button
                  variant="contained"
                  sx={{
                    fontSize: "11px",
                    textTransform: "capitalize",
                    fontWeight: "bold",
                    padding: "6px 20px",
                    borderRadius: "10rem",
                    width: "115px",
                    height: "32px",
                    boxShadow: "none",
                    background: "#15741a",
                  }}
                  color="success"
                  onClick={handleClickButton}
                >
                  Add to Cart
                </Button>
              )}
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              mt: 1.5,
              mb: 0.5,
              flexWrap: "wrap",
              gap: "4px 8px",
              width: "100%",
              maxWidth: "100%",
              minWidth: 0,
              overflow: "hidden",
            }}
          >
            <Typography variant="body2" sx={{ fontWeight: "bold" }}>
              {currencyCode}
              {finalPrice?.toLocaleString()}/-
            </Typography>
            <Typography
              variant="body2"
              sx={{
                paddingLeft: "10px",
                // color: "#808080ab",
                color: "gray",
                textDecoration: "line-through",
              }}
            >
              {currencyCode}
              {price?.toLocaleString()}/-
            </Typography>
            &nbsp;&nbsp;
            <span style={{ color: "#FFBF00" }}> | </span>
            <Typography
              variant="body2"
              sx={{ paddingLeft: "10px", color: "#15741a" }}
            >
              Save{" "}
              <span style={{ fontWeight: "bold" }}>
                {currencyCode}
                {discount?.toLocaleString()}/-
              </span>
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              mt: 0.5,
              mb: 0.5,
            }}
          >
            <WatchLaterIcon sx={{ fontSize: "18px", color: "#15741a" }} />
            <Typography
              variant="caption"
              sx={{
                paddingLeft: "8px",
                fontWeight: "bold",
              }}
            >
              {formattedHours} hr : {minutes} mins
            </Typography>
          </Box>

          <Box
            sx={{
              height: "auto",
              my: 1,
              maxHeight: "auto",
            }}
          >
            {serviceDetails?.map((item: any, index: number) => (
              <Box sx={{ display: "flex", alignItems: "start" }} key={index}>
                <CheckIcon sx={{ color: "#15741a", padding: "5px" }} />
                <Typography variant="caption">{item}</Typography>
              </Box>
            ))}
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              mt: 0.5,
              mb: 0.5,
            }}
          >
            <Image
              src={Coin}
              alt="icon"
              style={{
                objectFit: "cover",
                width: "1.4rem",
                height: "1.4rem",
                borderRadius: "0.5rem",
              }}
              width={500}
              height={500}
              loading="lazy"
            />
            <Typography variant="caption" sx={{ paddingLeft: "8px" }}>
              {coin} Coin Cashback
            </Typography>
          </Box>
        </Box>
        {/* </Box> */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1,
            width: "100%",
            maxWidth: "100%",
            minWidth: 0,
            overflow: "hidden",
            px: { xs: "0.5rem", sm: 2 },
            pb: { xs: "1rem", sm: 2 },
            pt: 0,
            boxSizing: "border-box",
          }}
        >
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: makeYourOwnPackage
                ? { xs: "minmax(0, 1fr)", sm: "auto" }
                : { xs: "minmax(0, 1fr) minmax(0, 1fr)", sm: "auto auto" },
              gap: 1,
              width: "100%",
              maxWidth: "100%",
              minWidth: 0,
            }}
          >
          {makeYourOwnPackage ? (
            <Button
              variant="outlined"
              aria-hidden="false"
              sx={{
                fontSize: "11px",
                textTransform: "capitalize",
                fontWeight: "bold",
                py: 1,
                px: 2.5,
                minHeight: 44,
                borderRadius: "10rem",
                width: "100%",
                maxWidth: "100%",
                minWidth: 0,
                boxShadow: "none",
              }}
              color="success"
              onClick={handleEditPackage}
            >
              Edit Package
            </Button>
          ) : (
            <Button
              variant="outlined"
              sx={{
                fontSize: "12px",
                textTransform: "capitalize",
                fontWeight: "bold",
                py: 1,
                px: 2,
                minHeight: 44,
                borderRadius: "10rem",
                width: "100%",
                minWidth: 0,
                maxWidth: "100%",
                boxShadow: "none",
              }}
              color="success"
              onClick={handleViewDetails}
            >
              View Details
            </Button>
          )}
          <Button
            variant="outlined"
            color="warning"
            onClick={handleReferEarnNavigate}
            sx={{
              fontSize: "12px",
              textTransform: "capitalize",
              fontWeight: "bold",
              py: 1,
              px: 2,
              minHeight: 44,
              borderRadius: "10rem",
              width: "100%",
              minWidth: 0,
              maxWidth: "100%",
              boxShadow: "none",
              color: "#15741a",
              border: "1px solid #FFBF00",
            }}
          >
            <ShareIcon sx={{ mr: 0.5, fontSize: "20px" }} />
            Share
          </Button>
          </Box>
          {productDetailsAvailable == true && (
            <Box
              sx={{
                display: "flex",
                justifyContent: { xs: "center", sm: "flex-start" },
                width: "100%",
                maxWidth: "100%",
                minWidth: 0,
              }}
            >
              <Guide serviceId={id} />
            </Box>
          )}
        </Box>
        {isClicked && recommendedServices?.length > 0 && (
        <Box
          sx={{
            width: "100%",
            maxWidth: "100%",
            minWidth: 0,
            mt: 1,
            background: "#e6e3e390",
            borderRadius: bannerUrl ? "0 0 1rem 1rem" : "0.5rem",
            overflow: "hidden",
            boxSizing: "border-box",
            overscrollBehavior: "contain",
          }}
        >
          <Typography
            variant="caption"
            component="div"
            sx={{
              display: "block",
              px: 1,
              pt: 1,
              pb: 0.5,
              fontWeight: 700,
              color: "#123524",
              letterSpacing: "0.02em",
            }}
          >
            Best paired with
          </Typography>
          <Box
            className="salontym-best-paired-hscroll"
            onWheel={(e) => {
              const el = e.currentTarget;
              if (el.scrollWidth > el.clientWidth) {
                e.stopPropagation();
              }
            }}
            sx={{
              display: "flex",
              flexDirection: "row",
              flexWrap: "nowrap",
              alignItems: "stretch",
              gap: 0,
              width: "100%",
              maxWidth: "100%",
              minWidth: 0,
              boxSizing: "border-box",
              overflowX: "auto",
              overflowY: "hidden",
              px: 0.5,
              pb: 1.5,
              pt: 0.5,
              WebkitOverflowScrolling: "touch",
              overscrollBehavior: "contain",
              overscrollBehaviorX: "contain",
              overscrollBehaviorY: "none",
              touchAction: "pan-x",
              isolation: "isolate",
              position: "relative",
              "&::-webkit-scrollbar": {
                height: 6,
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "rgba(18, 53, 36, 0.35)",
                borderRadius: 3,
              },
            }}
          >
            {recommendedServices?.map((item: any, index: any) => (
              <Box
                key={index}
                sx={{
                  flex: "0 0 auto",
                  width: 244,
                  minWidth: 244,
                  maxWidth: 244,
                  boxSizing: "border-box",
                }}
              >
                <BestPairedDesktop
                  addOn={item?.addOn}
                  id={item?.id}
                  cid={item?.cid}
                  url={
                    item?.banner?.secureHttpPath ??
                    item?.coverImage.secureHttpPath
                  }
                  heading={item?.name}
                  subHeading={item?.subHeading}
                  price={item?.mrp}
                  aboutList={item?.aboutList}
                  serviceCharge={item?.serviceCharge}
                  productCost={item?.productCost}
                  min={item?.min}
                  finalPrice={item?.amount}
                  specialPrice={item?.specialPrice}
                  specialMessage={item?.specialMessage}
                  handleViewDetailsBestPaired={() =>
                    handleViewDetailsBestPaired(item)
                  }
                  updateCard={updateCard}
                  setUpdateCard={() => setUpdateCard(false)}
                  reloadViewDetailsItem={reloadViewDetailsItem}
                  productDetailsAvailable={item?.productDetailsAvailable}
                  handleOpenViewDetailsRsOne={() =>
                    handleOpenViewDetailsRsOne(item, index)
                  }
                />
              </Box>
            ))}
          </Box>
        </Box>
        )}
      </Box>
      {!bannerUrl && <Divider />}
      <MaxServiceAlert
        openInfo={openMaxService}
        handleClose={() => setOpenMaxService(false)}
      />
      <ShareService
        drawerOpen={openShareDrawer}
        closeDrawer={() => setOpenShareDrawer(false)}
      />
    </Box>
  );
};

export default MobileCard;
